'use client';

import { useRouter } from 'next/router';
import { useTranslation } from 'next-i18next';
import { useViewportDevice } from '@zep/react';
import { Button } from '@zep/ui';
export const SuccessActionButtons = ({
  spaceHashId,
  entryMapHashId
}: {
  spaceHashId: string;
  entryMapHashId: string;
}) => {
  const router = useRouter();
  const {
    t
  } = useTranslation(['subscription']);
  const {
    isPortraitMobile
  } = useViewportDevice();
  return <div className="flex w-full justify-end gap-[8px]" data-sentry-component="SuccessActionButtons" data-sentry-source-file="SuccessActionButtons.tsx">
      <Button variant={'sub'} size={isPortraitMobile ? 'md' : 'lg'} isFullWidth={isPortraitMobile} onClick={() => router.replace(`/me/spaces/${spaceHashId}/plan`)} data-sentry-element="Button" data-sentry-source-file="SuccessActionButtons.tsx">
        {t('subscription:payment.complete.manageSubscription')}
      </Button>
      <Button size={isPortraitMobile ? 'md' : 'lg'} isFullWidth={isPortraitMobile} onClick={() => router.replace(`/play/${entryMapHashId}`)} data-sentry-element="Button" data-sentry-source-file="SuccessActionButtons.tsx">
        {t('subscription:payment.complete.goSpace')}
      </Button>
    </div>;
};